// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentSurveyQuestion {
    static getAttributeTypeMap() {
        return BasicEnrollmentSurveyQuestion.attributeTypeMap;
    }
}
BasicEnrollmentSurveyQuestion.discriminator = undefined;
BasicEnrollmentSurveyQuestion.additionalProperties = false;
BasicEnrollmentSurveyQuestion.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "answers",
        "baseName": "answers",
        "type": ""
    },
];
//# sourceMappingURL=basicEnrollmentSurveyQuestion.js.map